module.exports = __webpack_public_path__ + "expired-badge.svg?4099cd9d19d6598d400db6a4d192ad95";